import { createContext, useContext, useEffect, useState } from 'react';
import { auth, googleProvider } from '../firebase';
import { onAuthStateChanged, signInWithPopup, signOut } from 'firebase/auth';


const AuthContext = createContext();


export function AuthProvider({ children }) {
const [user, setUser] = useState(null);
const [loading, setLoading] = useState(true);


useEffect(() => {
const unsub = onAuthStateChanged(auth, (u) => {
setUser(u || null);
setLoading(false);
});
return () => unsub();
}, []);


const signInGoogle = async () => {
await signInWithPopup(auth, googleProvider);
};


const signOutUser = async () => {
await signOut(auth);
};


return (
<AuthContext.Provider value={{ user, loading, signInGoogle, signOutUser }}>
{children}
</AuthContext.Provider>
);
}


export function useAuth() {
return useContext(AuthContext);
}